var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"inline-block","margin-bottom":"20px"}},[_c('label',{staticStyle:{"margin-bottom":"1px"}},[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_c('br'),_vm._v(_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }